<template>
<!--
  Local URL: http://localhost:8080/
  Required Group Membership: None
  Purpose: This page is just a placeholder. When the user hits the root of the site, they will be taken to the 
  SquareSpace site at https://www.vectorbyte.org/ which is managed by Sam Rund. They should never see this page.
-->
  <div class="content-wrapper">
    <NewBaseTemplate>
      
      <div class="top-section">
        <b-container fluid style="padding: 60px 175px 60px 175px">         
            <b-row>
              <b-col sm="12" lg="7" md="10" id="description-container">
                <h3 class="description">This page should never be visible to the user. Hitting this route should 
                  bounce the user out to the SquareSpace site.</h3>
              </b-col>
              <b-col md="6" sm="12" lg="5">
                <p class="sub-description">
                  This new initiative – VectorByte - will establish a global open access data platform... 
                </p>
              </b-col>
            </b-row>
          
        </b-container> 
      </div>  
      <div class="bottom-section">
        <b-container fluid>
           <b-row> 
            <p class="bottom">
              A new 5-year NSF Division of <a href='#' class="link">Biological Infrastructure grant</a>, awarded to 
              <a href='#' class="link">Leah R. Johnson</a> (Virginia Tech),
              <a href='#' class="link">Sadie J. Ryan</a> (University of Florida), 
              <a href='#' class="link">Samuel Rund</a> (University of Notre Dame) 
              in collaboration with <a href='#' class="link">Samraat Pawar</a> (Imperial College London), is 
              launching in August 2020. <br/>
              This new initiative – VectorByte - will establish a global open access data platform to study disease 
              vectors. This 5-year project will not only serve as a hub for biological trait and abundance data for 
              human and non-human disease vectors, but will also provide analysis tools and training to a wide 
              audience of researchers and practitioners.
            </p>
           </b-row>
        </b-container>
      </div>   
    </NewBaseTemplate>
  </div>  
</template>

<script>
// @ is an alias to /src
import NewBaseTemplate from "@/layouts/NewBaseTemplate.vue";

export default {
  name: "home",
 // mixins: [BaseTemplate],
  components: {
    NewBaseTemplate
  }
};
</script>

<style scoped>
  

  .top-section{
     background-color: #64ACBE;
     color: white;
    
  }

  .bottom-section{
    background-color: white;
    padding: 126px 0px 150px 0px;
  }

  .description{
    text-align: left;
    font: 20px Poppins;
    white-space: pre-wrap;
    font-weight: bold;
    font-size: 39.74px;
    font-style: normal;
    text-shadow: none;
    text-transform: none;
    letter-spacing: 0em;
    line-height: 1.3328;
    overflow-wrap: break-word;
  }

  .sub-description{
    font: 20px Poppins;
    font-size: 24px;
    text-align: left;
    text-shadow: none;
    line-height: 1.8;
    margin: 0px 0px 0px 150px;
  }

  .bottom{
    color: black;
    text-shadow: none;
    text-align: left;
    font: 16px Poppins;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.8;
    padding: 30px 175px 0px 175px;
  }

  .link{
    font-family: 16px Poppins;
    border-bottom: 1px solid currentColor;
    text-decoration: none;
    color: #EB513E;
  }
</style>